<mat-form-field appearance="outline" [class]="class" class="w-100">
  <mat-label>{{'table_column_management.add_remove_columns_lbl' | translate}}</mat-label>
  <mat-select class="w-100" #select [formControl]="columnsControl" multiple>
    <mat-select-trigger>
      {{(getItemName(columnsControl.value?.[0]!)! | translate) || ''}}
      @if ((columnsControl.value?.length! || 0) > 1) {
        <span class="example-additional-selection">
          (+{{(columnsControl.value?.length! || 0) - (columnsControl.value?.length! == allColumns.length + 1 ? 2: 1)}} {{columnsControl.value?.length! === 2 ? 'other' : 'others'}})
        </span>
      }
    </mat-select-trigger>

    <mat-option [disabled]="columnsControl.value?.includes(SELECT_ALL_VALUE)" [value]="SELECT_ALL_VALUE">
    {{'table_column_management.select_all' | translate}}</mat-option>
    @for (column of allColumns; track column) {
<mat-option [disabled]="!columnsControl.value?.includes(SELECT_ALL_VALUE) &&
          columnsControl.value?.includes(column.id) &&
           columnsControl.value?.length == 1
           " [value]="column.id">{{column.name | translate}}</mat-option>
    }

  </mat-select>
</mat-form-field>